import React from "react";
import { Stack } from "@fluentui/react";
import { Form as FormikForm } from "formik";

const Form = ({ children, styles, width }) => {
  return (
    <FormikForm styles={styles?.form}>
      <Stack
        tokens={{ childrenGap: 20 }}
        styles={styles?.form || { root: { width: width || 600 } }}
      >
        {children}
      </Stack>
    </FormikForm>
  );
};

export default Form;
